import { DebugService } from '../shared/services/debug.service.js';
import { REFI_VEHICLE_LOAN_CONST } from '../shared/constants/app.constants.js';
import { ApiService } from '../core/services/api/api.service.js';

class _VehicleReviewService {
  constructor() {
    this.debug = new DebugService('VehicleReviewService');
    this._vehicleInfoModel = {
      year: '',
      make: '',
      model: '',
      vin: '',
    };
  }

  getVehicleInfo(eAppId) {
    const url = REFI_VEHICLE_LOAN_CONST.GET_VEHICLE_INFORMATION_URL(eAppId);
    return ApiService.get(url, {}, REFI_VEHICLE_LOAN_CONST.TIMEOUT_IN_MS).then(
      (res) => {
        const { year, make, model, vin } = res;
        if (year && make && model && vin) {
          return res;
        }
        throw new Error('no vehicle found');
      },
      (err) => {
        throw new Error(`operation unsuccessful ${err?.message ?? err}`);
      }
    );
  }

  getStips(eAppId) {
    const url = REFI_VEHICLE_LOAN_CONST.GET_APPLICATION_TASKS_URL(eAppId);
    return ApiService.get(url, {}, REFI_VEHICLE_LOAN_CONST.TIMEOUT_IN_MS);
  }
}

export const VehicleReviewService = new _VehicleReviewService();
